import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import { APP_ROUTES } from '../routes';
import { useCompany } from '../context/CompanyContext';
import { useAuth } from '../hooks/useAuth';
import Loader from '../components/Loader';
import ErrorPage from '../pages/ErrorPage';

export default function MainLayout() {
    const navigate = useNavigate();
    const location = useLocation();
    const { company, isLoadingCompany } = useCompany();
    const { state: authState } = useAuth();
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const getActiveNavItem = () => {
        const path = location.pathname;
        if (path.includes(APP_ROUTES.COMPANY)) return 'companies';
        if (path.includes(APP_ROUTES.USERS)) return 'users';
        if (path.includes(APP_ROUTES.MY_COMPANY)) return 'my-company';
        if (path.includes(APP_ROUTES.INCIDENT_LIST)) return 'incidents';
        if (path.includes(APP_ROUTES.DASHBOARD)) return 'dashboard';
        return '';
    };

    const handleNavItemClick = (itemId: string) => {
        switch (itemId) {
            case 'dashboard': navigate(APP_ROUTES.DASHBOARD); break;
            case 'companies': navigate(APP_ROUTES.COMPANY); break;
            case 'users': navigate(APP_ROUTES.USERS); break;
            case 'incidents': navigate(APP_ROUTES.INCIDENT_LIST); break;
            case 'my-company': navigate(APP_ROUTES.MY_COMPANY); break;
            default: break;
        }
    };

    if (isLoadingCompany) {
        return <Loader />;
    }

    if (!company && !authState.user?.roles.includes('super-admin')) {
        return <ErrorPage title="Company Not Found" message="We couldn\'t find company details for your account. Please contact support." showLogout />;
    }

    return (
        <div className="flex h-screen bg-gray-50 overflow-hidden">
            <Sidebar 
                activeNavItem={getActiveNavItem()}
                onNavItemClick={handleNavItemClick}
                isOpen={isSidebarOpen}
                onClose={() => setSidebarOpen(false)}
            />
            <div className="flex-1 flex flex-col min-w-0">
                <Navbar onMenuClick={() => setSidebarOpen(true)} />
                <main className="flex-1 overflow-auto p-4 sm:p-6">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
